module.exports = __webpack_public_path__ + "score2.mp3";